import { BaseService } from '../../../../../core/services/base.service';
import { CandidateAiSummaryView } from '../models/candidate-ai-summary.model';

const rethrow = (error: Error) => {
  throw error;
};

export class CandidateAiSummaryService {
  static Get(
    candidateId: string,
    CallbackCatch?: (error: Error) => void
  ): Promise<CandidateAiSummaryView | undefined> {
    return BaseService.Get(
      `/candidates/${candidateId}/ai-summary`,
      CallbackCatch,
      false
    );
  }

  static Generate(candidateId: string): Promise<CandidateAiSummaryView> {
    return BaseService.Post(
      `/candidates/${candidateId}/ai-summary`,
      {},
      rethrow,
      false
    );
  }

  static DownloadPdf(candidateId: string): Promise<Blob> {
    return BaseService.Blob(
      'GET',
      `/candidates/${candidateId}/ai-summary/pdf`,
      undefined,
      rethrow,
      false
    );
  }
}
